import { ReactNode, useState } from 'react'
import { useRecoilState, useRecoilValue } from 'recoil'
import { Step, Steps } from 'intro.js-react'
import { Toaster } from 'react-hot-toast'
import { modalContentState, modalOpenState } from '../../atoms/layout'
import { useGetProfile } from '../../api/auth'
import { Dialog, Stack } from '@mui/material'

interface Props {
  children: ReactNode
  header?: ReactNode
  introSteps?: Step[]
}

export default function PageContainer({ children, introSteps, header }: Props) {
  const [isModalOpen, setModalOpen] = useRecoilState(modalOpenState)
  const modalContent = useRecoilValue(modalContentState)
  const [intro, setIntro] = useState<boolean>(false)
  useGetProfile()
  return (
    <div className="flex flex-col h-screen">
      {header && header}
      <Stack direction="column" sx={{ height: '100%', p: 2, pb: 0 }}>
        {children}
      </Stack>
      <Dialog
        open={isModalOpen}
        onClose={() => setModalOpen(false)}
        sx={{ '.MuiDialog-paper': { p: 1 } }}
      >
        {modalContent}
      </Dialog>
      <Steps
        steps={introSteps ?? []}
        initialStep={0}
        enabled={intro}
        onExit={() => setIntro(false)}
        options={{
          nextLabel: 'بعدی',
          prevLabel: 'قبلی',
          doneLabel: 'تمام',
          tooltipClass: 'intro-tooltip',
        }}
      />
      {introSteps && (
        <div className="fixed bottom-3 left-3" id="ssss">
          <img
            alt="help"
            src="/icons/help.svg"
            className="cursor-pointer"
            onClick={() => setIntro(true)}
          />
        </div>
      )}
      <Toaster
        position="bottom-center"
        toastOptions={{ style: { padding: 'auto 1rem', border: '2px solid gray' } }}
      />
    </div>
  )
}
